<template>
    <div>

        <!-- SundAir Login ------------------------------------------------- -->
        <div id="sundair-login" class="travelo-login-box sdr-box" style="width: 540px;">
            <center><img src="/res/images/logo.png" alt="Sundair"></center>
            <br />
            <h2><center>{{ sundairtravelcenter[getCurrentLocale] }}</center></h2>
            <div class="seperator"><label>{{ hello[getCurrentLocale] }}</label></div>
            <br /><br /><br />
            <form @submit.prevent="onSubmit_Login">
                <div class="form-group">
                    <input type="text" class="input-text full-width" :placeholder="email[getCurrentLocale]" v-model="user_login_user">
                </div>
                <div class="form-group">
                    <input type="password" class="input-text full-width" :placeholder="password[getCurrentLocale]" v-model="user_login_password">
                </div>
                <div class="form-group">
                    <a href="#sundair-resetpassword" class="forgot-password pull-right goto-signup soap-popupbox">{{ forgotpassword[getCurrentLocale] }}</a>
                </div>
                <br /><br /><br />
                <button class="btn-medium uppercase full-width"><i class="soap-icon-trunk-1"></i>&nbsp;&nbsp;{{ signin[getCurrentLocale] }}</button>
            </form>
            <div class="seperator"></div>
            <p>{{ stillnoaccount[getCurrentLocale] }}<a href="#sundair-signup" class="goto-signup soap-popupbox">&nbsp;&nbsp;&nbsp;{{ signup[getCurrentLocale] }}.</a></p>
        </div>


        <!-- SundAir Signup ------------------------------------------------ -->
        <div id="sundair-signup" class="travelo-login-box sdr-box" style="width: 540px;">
            <center><img src="/res/images/logo.png" alt="Sundair"></center>
            <br />
            <h2><center>{{ sundairtravelcenter[getCurrentLocale] }}</center></h2>
            <div class="seperator"><label>{{ hello2[getCurrentLocale] }}</label></div>
            <br /><br /><br />
            <form @submit.prevent="onSubmit_Signup">
                <div class="form-group">
                    <input type="text" class="input-text full-width" :placeholder="email[getCurrentLocale]" v-model="user_signup_email">
                </div>
                <div class="form-group">
                    <input type="password" class="input-text full-width" :placeholder="password[getCurrentLocale]" v-model="user_signup_password">
                </div>
                <br /><br /><br />
                <button class="btn-medium uppercase full-width"><i class="soap-icon-trunk-1"></i>&nbsp;&nbsp;{{ signup[getCurrentLocale] }}</button>
            </form>
            <div class="seperator"></div>
            <p>{{ havealreadyanaccount[getCurrentLocale] }}<a href="#sundair-login" class="goto-signup soap-popupbox">&nbsp;&nbsp;&nbsp;{{ signin[getCurrentLocale] }}.</a></p>
        </div>


        <!-- SundAir Reset Password ---------------------------------------- -->
        <div id="sundair-resetpassword" class="travelo-login-box sdr-box" style="width: 540px;">
            <center><img src="/res/images/logo.png" alt="Sundair"></center>
            <br />
            <h2><center>{{ sundairtravelcenter[getCurrentLocale] }}</center></h2>
            <div class="seperator"><label>{{ hello3[getCurrentLocale] }}</label></div>
            <br /><br />
            <p style="color: red;">{{ note[getCurrentLocale] }}: {{ putinemailadress[getCurrentLocale] }}</p>
            <br />
            <form @submit.prevent="onSubmit_ResetPassword">
                <div class="form-group">
                    <input type="text" class="input-text full-width" :placeholder="email[getCurrentLocale]" v-model="user_resetpassword_email">
                </div>
                <br /><br /><br />
                <button class="btn-medium uppercase full-width"><i class="soap-icon-trunk-1"></i>&nbsp;&nbsp;{{ resetpassword[getCurrentLocale] }}</button>
            </form>
            <div class="seperator"></div>
            <p>{{ havealreadyanaccount[getCurrentLocale] }}<a href="#sundair-login" class="goto-signup soap-popupbox">&nbsp;&nbsp;&nbsp;{{ signin[getCurrentLocale] }}.</a></p>
        </div>

    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import { mapActions } from 'vuex';

    import { eventBus } from '../../../main';


    export default {

        /* >>> *************************************************************** / /* Data */
        data: function() {

            return {
                language: {
                    en: 'Language',
                    de: 'Sprache',
                },
                // >>> ------------------------------------
               hello: {
                    en: 'Hello, welcome back to your Account',
                    de: 'Hallo, willkommen zurück in Ihrem Account',
                },
               hello2: {
                    en: 'Hello, create your new account',
                    de: 'Hallo, erstellen Sie Ihren neuen Account',
                },
               hello3: {
                    en: 'Hello, you have forgotten your password?',
                    de: 'Hallo, Sie haben Ihr Passwort vergessen?',
                },
                sundairtravelcenter: {
                    en: 'Sundair Travelcenter',
                    de: 'Sundair Reisezentrale',
                },
                email: {
                    en: 'EMail',
                    de: 'E-Mail Adresse',
                },
                password: {
                    en: 'Password',
                    de: 'Passwort',
                },
                forgotpassword: {
                    en: 'Forgot password?',
                    de: 'Passwort vergessen?',
                },
                stillnoaccount: {
                    en: "Don't have a Sundair account?",
                    de: 'Sie haben noch kein Sundair Konto?',
                },
                signin: {
                    en: "Sign in",
                    de: 'Anmelden',
                },
                signup: {
                    en: "Sign up",
                    de: 'Registrieren',
                },
                resetpassword: {
                    en: "Reset Password",
                    de: 'Passwort zurücksetzen',
                },
                havealreadyanaccount: {
                    en: "Already have a Sundair account?",
                    de: 'Sie haben bereits ein Sundair Konto?',
                },
                putinemailadress: {
                    en: "Enter your email address and we will send you a new password.",
                    de: 'Geben Sie Ihre E-Mail Adresse ein und wir senden Ihnen ein neues Passwort.',
                },
                note: {
                    en: "Note",
                    de: 'Hinweis',
                },
                passwordwasreseted: {
                    en: "Password has been reset. Check your e-mails.",
                    de: 'Passwort wurde zurück gesetzt. Schauen Sie in Ihre E-Mails.',
                },
                emailwassent: {
                    en: "An email has been sent to your email address.",
                    de: 'Eine E-Mail wurde an Ihre E-Mail-Adresse gesendet.',
                },
                // >>> ------------------------------------
                errmsg_passwordorusernamemissing: {
                    en: "Please fill in completely.",
                    de: 'Bitte vollständig ausfüllen.',
                },
                // >>> ------------------------------------
                user_login_user: '',
                user_login_password: '',
                // >>> ------------------------------------
                user_signup_email: null,
                user_signup_password: null,
                // >>> ------------------------------------
                user_resetpassword_email: null,
                // >>> ------------------------------------
                lang: 'de'
            };

        }, // eo funtion data()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Computed */
        computed: {

            ...mapGetters([
                'getCurrentLocale',
                'getFlagSharedAgencyLoggedIn', // is Agency logged in?'
            ]),

        }, // eo computed{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** /  /* LifeCycles */
        /***********************************************************************
        * Lifecyclehook::created
        *
        * Desc:
        * Note:
        *
        */
		created: function () {

            let me = this;


            me.$toc('>>> shared/header/SundairLogin.vue >>> created');
            eventBus.$on('call_auth_passwordReset_success', this.onEmit_PasswordResetSuccess);
            eventBus.$on('call_auth_userCreate_success', this.onEmit_CreateUserSuccess);

        }, // eo function created()


        /***********************************************************************
        * Lifecyclehook::beforeDestroy
        *
        * Desc: Destroy Listener.
        * Note:
        *
        */
        beforeDestroy: function() {

            let me = this;


            me.$toc('>>> shared/header/SundairLogin.vue >>> beforeDestroy');
            eventBus.$off('call_auth_passwordReset_success', this.onEmit_PasswordResetSuccess);
            eventBus.$off('call_auth_userCreate_success', this.onEmit_CreateUserSuccess);

        }, // eo function beforeDestroy()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Methods */
        methods: {

            ...mapActions([
                'actn_setCurrentLocale',
                'actn_call_auth_login', // call:
                'actn_call_auth_create', // call: signup
                'actn_call_auth_passwordReset', // call:
            ]),


            /******************************************************************* 'Listeners - Common'
            * Listeners:
            *******************************************************************/
            /*******************************************************************
            * onSubmit_Login()
            *
            * Desc: Login.
            * Note:
            *
            */
            onSubmit_Login: function(submitEvent) {

                let me = this;


                me.$toc('>>> shared/header/SundairLogin.vue >>> onSubmit_Login');
                // >>> Guard ------------------------------
                if (this.getFlagSharedAgencyLoggedIn === true) {
                    me.$toasted.global.sdr_app_error({
                        message : 'Login not possible. Agency is logged in.'
                    });
                    return;
                }


                if (this.user_login_user !== '' && this.user_login_password !== '') {
                    this.actn_call_auth_login({ email: this.user_login_user, password: this.user_login_password});
                } else {
                    me.$toasted.global.sdr_app_error({ // #762
                        message : me.errmsg_passwordorusernamemissing[me.getCurrentLocale]
                    });
                }

            }, // eof onSubmit_Login()


            /*******************************************************************
            * onSubmit_Signup()
            *
            * Desc: Sign up.
            * Note:
            *
            */
            onSubmit_Signup: function() {

                let me = this;


                me.$toc('>>> shared/header/SundairLogin.vue >>> onSubmit_Signup');
                if (this.user_signup_email !== null && this.user_signup_password !== null) {
                    this.actn_call_auth_create({ email: this.user_signup_email, password: this.user_signup_password });
                } else {
                    me.$toasted.global.sdr_app_error({ // #762
                        message : me.errmsg_passwordorusernamemissing[me.getCurrentLocale]
                    });
                }

            }, // eo function onSubmit_Signup()


            /*******************************************************************
            * onSubmit_ResetPassword()
            *
            * Desc: Reset Password.
            * Note:
            *
            */
            onSubmit_ResetPassword: function() {

                let me = this;


                me.$toc('>>> shared/header/SundairLogin.vue >>> onSubmit_ResetPassword');
                if (this.user_resetpassword_email !== null) {
                    this.actn_call_auth_passwordReset({ email: this.user_resetpassword_email });
                }

            }, // eo function onSubmit_ResetPassword()


            /*******************************************************************
            * onEmit_PasswordResetSuccess()
            *
            * Desc:
            * Note:
            *
            */
            onEmit_PasswordResetSuccess: function() {

                let me = this;


                me.$toc('>>> shared/header/SundairLogin.vue >>> onEmit_PasswordResetSuccess');
                me.$toasted.global.sdr_app_info({
                    message : this.passwordwasreseted[this.getCurrentLocale]
                });

                tjq("#soap-popupbox")[0].style = 'display: none;'; // close little modal

            }, // eo function onEmit_PasswordResetSuccess()


            /*******************************************************************
            * onEmit_PasswordResetSuccess()
            *
            * Desc:
            * Note:
            *
            */
            onEmit_CreateUserSuccess: function() {

                let me = this;


                me.$toc('>>> shared/header/SundairLogin.vue >>> onEmit_CreateUserSuccess');
                me.$toasted.global.sdr_app_info({
                    message : this.emailwassent[this.getCurrentLocale]
                });

                tjq("#soap-popupbox")[0].style = 'display: none;'; // close little modal

            }, // eo function onEmit_CreateUserSuccess()

        }, // eo methods{}
        /* <<< ****************************************************************/

    };
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/shared/header/SundairLogin.vue